export default __webpack_public_path__ + "3fb95f5c474ccc9c10d4ec729e64d002.png";